<template>
  <div class="page">
    <kdProblemIndex :problemData.sync="problemData" :view-only="isViewOnly"></kdProblemIndex>
  </div>
</template>

<script>
import {getStorage, setStorageNew} from "@/util/localStor";
import kdProblemIndex from "@/components/kdProblemDetails/kdProblemIndex.vue";
import {problemAddApi, problemEditApi} from "@/api/feedbackKD";

export default {
  components: { kdProblemIndex },
  data() {
    // 函数说明：初始化页面数据模型
    return {
      problemData: {},
      newProblemData: {},
      isViewOnly: false,
    };
  },
  async created() {
    // 函数说明：在创建阶段从本地存储中读取KD问题详情数据
    this.problemData = getStorage("problemDataKD");
    const data = getStorage("problemDataKD")

    //处理转换JSON数据
    this.handleProblemData(data);
    this.getMetaData()
  },

  watch: {
    problemData: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
          this.newProblemData = newVal
          this.kdHandleSave();
        } 
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    getMetaData() {
      var fullPath = this.$route.fullPath;
      // 修改导航跳转路径 标题
      if(fullPath.includes('allDetail')) {
        this.isViewOnly = true;
        this.$route.meta.father = "查看反馈单";
        if (sessionStorage.getItem('goBackPath')) {
          this.$route.meta.fatherPath = sessionStorage.getItem('goBackPath');
        } else {
          this.$route.meta.fatherPath = '/KDAddFeedback';
        }
      } else {
        this.isViewOnly = false;
        this.$route.meta.father = "质量问题审核"
        this.$route.meta.fatherPath = '/KDlookList';
      }
    },
    async kdHandleSave(){
      if (this.isViewOnly) {
        return;
      }
      //监听实时保存KD表单信息详情
      try {
        if(this.newProblemData){
          // this.form.questionContent = this.form.questionDescriptionAndFiles.faultDescription;
          const submitData = JSON.parse(JSON.stringify(this.newProblemData));
          Array.isArray(submitData.feedbackPurpose) && (submitData.feedbackPurpose = submitData.feedbackPurpose.join(","));
          submitData.questionDescriptionAndFiles = JSON.stringify(submitData.questionDescriptionAndFiles);
          // submitData["languageType"] = this.$i18n.locale;
          // submitData.vinCheckRespList.map((item, index) => {
          //   // 获取故障类型中文字典项
          //   const zhFaultTypeDictItem = this.kdFaultTypeList.find((item2) => {
          //     return item.faultType === item2.value;
          //   });
          //   submitData.vinCheckRespList[index].faultTypeZh =
          //     zhFaultTypeDictItem.code.slice(0, -2);
          //   // 获取故障类型中文字典项
          //   const zhRepairPlanDictItem = this.kdRepairPlanList.find((item2) => {
          //     return item.repairPlan === item2.value;
          //   });
          //   submitData.vinCheckRespList[index].repairPlanZh =
          //     zhRepairPlanDictItem.code.slice(0, -2);
          // });
          let res = {};
          if (submitData.questionId) {
            res = await problemEditApi({ data: submitData });
          }
          if (res.status == 0) {
            setStorageNew("problemDataKD", submitData);
            // this.dialogVisible = false;
            // this.$DonMessage.success(this.$t("message.czcg"));
            // this.$emit("success", res.data);
          } else {
            this.$DonMessage.error(res.message);
          }
        }
        
      } catch (error) {
        console.error(error);
      }
    },

    handleProblemData(data){
      let qdf = {};
      try {
        if (data.questionDescriptionAndFiles && typeof data.questionDescriptionAndFiles === 'string') {
          qdf = JSON.parse(data.questionDescriptionAndFiles);
        } else if (data.questionDescriptionAndFiles && typeof data.questionDescriptionAndFiles === 'object') {
          qdf = data.questionDescriptionAndFiles;
        }
      } catch (e) {
        console.error("Failed to parse questionDescriptionAndFiles", e);
      }
      this.problemData.questionDescriptionAndFiles = {
        faultDescription: qdf.faultDescription || data.faultDescription || "",
        faultDescriptionList: qdf.faultDescriptionList || data.faultDescriptionList || [],
        isUnboxOverall: qdf.isUnboxOverall ?? data.isUnboxOverall ?? 1,
        unboxOverallList: qdf.unboxOverallList || data.unboxOverallList || [],
        isBoxLabel: qdf.isBoxLabel ?? data.isBoxLabel ?? 1,
        boxLabelList: qdf.boxLabelList || data.boxLabelList || [],
        isBoxDamage: qdf.isBoxDamage ?? data.isBoxDamage ?? 1,
        boxDamageList: qdf.boxDamageList || data.boxDamageList || [],
        isPartOverall: qdf.isPartOverall ?? data.isPartOverall ?? 1,
        partOverallList: qdf.partOverallList || data.partOverallList || [],
        isPartDetail: qdf.isPartDetail ?? data.isPartDetail ?? 1,
        partDetailList: qdf.partDetailList || data.partDetailList || [],
        isPartComparison: qdf.isPartComparison ?? data.isPartComparison ?? 1,
        partComparisonList: qdf.partComparisonList || data.partComparisonList || [],
        isSupplierInfo: qdf.isSupplierInfo ?? data.isSupplierInfo ?? 1,
        supplierInfoList: qdf.supplierInfoList || data.supplierInfoList || [],
        isOtherEvidence: qdf.isOtherEvidence ?? data.isOtherEvidence ?? 1,
        otherEvidenceList: qdf.otherEvidenceList || data.otherEvidenceList || [],
        remark: qdf.remark || data.remark || "",
      };
    }
  }
};
</script>

<style src="@/assets/css/qualityStyle.css"></style>
